<template>
  <div class="ques-sheet"
       v-if="questions">
    <p v-if="courseName" class="courseName"> <i class="el-icon-document"></i> {{courseName || ''}}</p>
    <ul>
      <li v-for="(item, index) in questions"
          :key="index"
          class="firstLi">
        <div class="wrap-group-name"
             @click="toggle(index)">
          <span class="group-fold"></span>
          <span class="group-name">{{item.showSerialNum}}、{{item.viewTypeName}}</span>
        </div>
        <ul class="list">
          <li v-for="(ele,idx) in item.list"
              :key="idx"
              :class="sign(ele)"
              @click="toggleSmallQues(index,idx,null,null)">&nbsp;
            <span class="num-val">{{ele.showSerialNum}}</span>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'ExamQuesList',
  data() {
    return {
      newNum: 0,
      SerialNum: 0,
    }
  },
  computed: {
    ...mapGetters(['questions', 'currentQuestion']),
  },
  props: {
    courseName: {
      type: String,
      default: '',
    },
  },
  methods: {
    toggleSmallQues(quesType, quesIndex, smallIndex, smallId) {
      // debugger;
      if (smallId) {
        this.$emit(
          'quesFn',
          quesType,
          quesIndex,
          smallIndex,
          '#smallId' + smallId,
          this.currentQuestion
        )
      } else {
        this.$emit(
          'quesFn',
          quesType,
          quesIndex,
          smallIndex,
          smallId,
          this.currentQuestion
        )
      }
    },
    //答题卡标记字符
    sign(ques) {
      const myQues = JSON.parse(JSON.stringify(ques))
      // 判断是否部分完成
      if(ques.smallContent&&ques.smallContent.length>0){
        // 有小题
        let anCount = 0
        let toCon=ques.smallContent.length
        ques.smallContent.forEach(item=>{
          if(item.userAnswer){
            anCount++
          }
        })
        if(anCount!==0&&anCount<toCon){
          myQues.isComPart=true
        }else{
          myQues.isComPart=false
        }
      }
      // if (
      //   //当前题 已答
      //   ques.questionID === this.currentQuestion.questionID &&
      //   ques.isAnswer === 1 &&
      //   ques.isMark !== 1
      // ) {
      //   return 'current'
      // } else if (
      //   //当前题 标记
      //   ques.questionID === this.currentQuestion.questionID &&
      //   ques.isMark === 1
      // ) {
      //   return 'current marked'
      // } else if (
      //   //已答 未标记
      //   (ques.isMark === 0 || ques.isMark === null) &&
      //   ques.isAnswer === 1
      // ) {
      //   return 'done'
      // } else if (ques.isMark === 1 && ques.isAnswer === 1) {
      //   //已答 已标记
      //   return 'done marked'
      // } else if (ques.isMark === 1 && ques.isAnswer !== 1) {
      //   //未答 已标记
      //   return 'marked'
      // } else if (ques.questionID === this.currentQuestion.questionID) {
      //   // 当前题
      //   return 'current'
      // } else if (ques.isAnswer === 1) {
      //   // 已答
      //   return 'done'
      // }

      let re=''
      if(myQues.isAnswer == 1 && myQues.isComPart){
        re='dopart'
      }else if(myQues.isAnswer == 1 && !myQues.isComPart){
        re='done'
      }
      if( myQues.questionID == this.currentQuestion.questionID){
        re='current'
      }
      if(myQues.isMark == 1){
        re=re+' marked'
      }
      return re
    },

    //切换显隐
    toggle(index) {
      if ($('.ques-sheet').find('.firstLi').eq(index).hasClass('active')) {
        $('.ques-sheet').find('.firstLi').eq(index).removeClass('active')
      } else {
        $('.ques-sheet').find('.firstLi').eq(index).addClass('active')
      }
    },
  },
}
</script>
<style lang="scss" scoped>
$imgUrl: '~@/assets/images/doExam/';
.ques-sheet {
  .courseName {
    padding: 5px 0;
    color: #007bff !important;
  }
  .active {
    .list {
      display: none;
    }
    .group-fold {
      width: 8px !important;
      height: 14px !important;
      background: url($imgUrl + 'icon-right.png') no-repeat !important;
      margin-right: 17px !important;
      position: relative;
      left: 5px;
    }
  }
  .wrap-group-name {
    cursor: pointer;
    .group-fold {
      display: inline-block;
      width: 15px;
      height: 8px;
      cursor: pointer;
      transition: 0.3s all;
      background: url($imgUrl + 'icon-down.png') no-repeat;
      margin-right: 10px;
    }
    .group-name {
      font-size: 16px;
      font-weight: 700;
      margin: 10px 0;
      color: #666;
    }
  }
  .list {
    margin-top: 8px;
    margin-bottom: 16px;
    overflow: hidden;
    li {
      float: left;
      /*width:28px;*/
      /*margin: 0 5px 8px 5px;*/
      width: 20%;
      margin-bottom: 8px;
      height: 28px;
      text-align: center;
      cursor: pointer;
      color: #000;
      .num-val {
        border: 1px solid #999;
        position: relative;
        width: 28px;
        height: 28px;
        font-size: 15px;
        border-radius: 4px;
        text-align: center;
        line-height: 28px;
        display: inline-block;
        overflow: hidden;
      }
      &.current .num-val {
        background-color: #447dff;
        border-color: #447dff;
        color: #fff;
      }
      &.done .num-val {
        background-color: #55db9a;
        border-color: #55db9a;
        color: #fff;
      }
       &.dopart .num-val::before {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        height: 100%;
        border-left: 5px solid #55db9a;
      }
      &.marked .num-val::after {
        content: '';
        position: absolute;
        bottom: 0;
        right: -12px;
        border-width: 0 11px 11px;
        border-style: solid;
        border-color: transparent transparent #ff5464;
      }
    }
  }
}
</style>
